import { useSelector, shallowEqual } from 'react-redux';
import type { LocationState } from 'redux-first-router';
import type { PrimaryCountryISO } from '@/constants/countries';
import { MarketPageType } from './types';

interface State {
  market: PrimaryCountryISO;
  sector?: string;
  secondary?: string;
  tertiary?: string;
  pathname: string;
  onAdvancedFilters?: (direction: 'asc' | 'desc') => void;
}

export const getMarketPageType = (
  market,
  sector,
  secondary,
  tertiary
): MarketPageType => {
  if (!market) return MarketPageType.HOME;
  if (!sector) return MarketPageType.MARKET;
  if (!secondary) return MarketPageType.SECTOR;
  if (!tertiary) return MarketPageType.SECONDARY;
  return MarketPageType.TERTIARY;
};

export default (): State & { marketPageType: MarketPageType } => {
  const { market, sector, secondary, tertiary, pathname } = useSelector<
    { location: LocationState },
    State
  >((state) => {
    const { pathname, payload } = state.location;
    const { market, sector, secondary, tertiary } = payload;

    return {
      market: market || 'us',
      sector,
      secondary,
      tertiary,
      pathname,
    };
  }, shallowEqual);
  const marketPageType = getMarketPageType(market, sector, secondary, tertiary);

  return {
    market,
    sector,
    secondary,
    tertiary,
    pathname,
    marketPageType,
  };
};
